// --- Helper Functions ---
function updateCheckboxState() {
  const checkbox = document.querySelector('#ani-checkbox-modal');
  const labelText = document.querySelector('.nf-incl-vat-header');

  if (checkbox && labelText) {
    if (checkbox.checked) {
      labelText.textContent = 'Incl. btw';
      localStorage.setItem(`${Shopify.shop}-inclCheckboxState`, 'true');
    } else {
      labelText.textContent = 'Excl. btw';
      localStorage.setItem(`${Shopify.shop}-inclCheckboxState`, 'false');
    }
  }
}

function inclCheckboxUpdate(state) {
  const checkbox = document.querySelector('#ani-checkbox-modal');
  if (!checkbox) return;
  checkbox.checked = state === 'true';
}

function show_more_func() {
  const content = document.querySelectorAll(".show-more-container");
  content.forEach(item => {
    const button = item.querySelector(".btn-show-more");
    if (!button) return;
    const maxHeight = parseInt(item.getAttribute("data-content-height"));
    if (button.previousElementSibling.childNodes[0].clientHeight >= maxHeight) {
      item.classList.add("show");
    } else {
      item.classList.remove("show");
    }
  });
}

function resetReadMore() {
  const readMoreContainers = document.querySelectorAll('.js-read-more');
  readMoreContainers.forEach(container => {
    if (!container) return;
    const desktopHeight = parseInt(container.dataset.height) || 200;
    const mobileHeight = parseInt(container.dataset.mobileHeight) || 200;
    const button = container.closest('.read-more-container')?.querySelector('.js-toogle-read-more');
    const readMoreContent = container.querySelector('.js-read-more-content');
    if (!button || !readMoreContent) return;

    const contentHeight = readMoreContent.getBoundingClientRect().height;
    const isDesktop = window.innerWidth >= 768;

    if ((isDesktop && desktopHeight <= contentHeight) || (!isDesktop && mobileHeight <= contentHeight)) {
      button.classList.remove('hidden');
    } else {
      button.classList.add('hidden');
    }

    if (container.classList.contains('open')) {
      container.style.maxHeight = contentHeight + "px";
    } else {
      container.style.maxHeight = (isDesktop ? desktopHeight : mobileHeight) + "px";
    }
  });
}

// --- DOMContentLoaded ---
document.addEventListener('DOMContentLoaded', () => {

  // 1. Show More buttons
  show_more_func();
  window.addEventListener("resize", show_more_func);
  document.querySelectorAll(".btn-show-more").forEach(button => {
    button.addEventListener("click", function() {
      const prev = this.previousElementSibling;
      const maxHeight = this.closest(".show-more-container").getAttribute("data-content-height");
      if (this.innerHTML === "Lees meer") {
        this.innerHTML = "lees minder";
        prev.style.maxHeight = (prev.childNodes[0].clientHeight + 30) + "px";
      } else {
        this.innerHTML = "Lees meer";
        prev.style.maxHeight = maxHeight + "px";
      }
    });
  });

  // 2. Global Read More
  const readMoreButtons = document.querySelectorAll('.js-toogle-read-more');
  readMoreButtons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      const readMoreContent = button.closest('.read-more-container').querySelector('.js-read-more');
      readMoreContent.classList.toggle('open');
      resetReadMore();
    });
  });
  resetReadMore();
  window.addEventListener("resize", resetReadMore);

  // 3. Incl. VAT Checkbox
  let inclCheckboxState = localStorage.getItem(`${Shopify.shop}-inclCheckboxState`);
  if (!inclCheckboxState) {
    inclCheckboxState = 'true';
    localStorage.setItem(`${Shopify.shop}-inclCheckboxState`, inclCheckboxState);
  }
  inclCheckboxUpdate(inclCheckboxState);
  updateCheckboxState();
  const inclCheckbox = document.querySelector('#ani-checkbox-modal');
  inclCheckbox?.addEventListener('change', e => {
    inclCheckboxUpdate(inclCheckbox.checked.toString());
    updateCheckboxState();
  });

  // 4. Hide trusted shops on scroll
  window.addEventListener('scroll', () => {
    const target = document.querySelector('._uuhri8');
    if (target && window.scrollY > 100) target.remove();
  });

  // 5. Product Reviews JSON-LD
  const productPage = document.querySelector('.product-page');
  if (productPage) {
    const productSkus = productPage.dataset.productSkus;
    const reviewsUrl = `https://wear2work.monkeydo.it/api/v1/reviews/get?shop_id=wear2work&sku=${productSkus}`;

    fetch(reviewsUrl)
      .then(res => res.json())
      .then(response => {
        const jsonLdScript = document.getElementById('product-jsonld');
        let jsonLdData = JSON.parse(jsonLdScript.textContent);
        if (!Array.isArray(jsonLdData)) jsonLdData = [jsonLdData];

        const productData = jsonLdData.find(item => item['@type'] === 'Product');
        if (productData) {
          if (!productData.review) productData.review = [];
          response.items.forEach(review => {
            productData.review.push({
              "@type": "Review",
              "author": { "@type": "Person", "name": review.customer.email },
              "datePublished": review.submittedAt,
              "reviewBody": review.comment,
              "name": review.title,
              "reviewRating": { "@type": "Rating", "ratingValue": review.rating, "bestRating": "5" }
            });
          });
          const totalRating = response.items.reduce((sum, r) => sum + r.rating, 0);
          productData.aggregateRating = {
            "@type": "AggregateRating",
            "ratingValue": (totalRating / response.items.length).toFixed(1),
            "reviewCount": response.items.length
          };
        }
        jsonLdScript.textContent = JSON.stringify(jsonLdData, null, 2);
      })
      .catch(console.error);
  }

  // 6. Header Reviews
  const reviewUrl = `https://feedback.monkeydo.it/api/v1/review/wear2worknl`;
  fetch(reviewUrl)
    .then(res => res.json())
    .then(data => {
      const average = parseFloat(data.ratings.average);
      const quantity = parseInt(data.ratings.quantity);

      const button = document.querySelector('.left-wrapper button');
      if (button) button.textContent = average.toFixed(2);

      const reviewsText = document.querySelector('.star-ratings')?.nextElementSibling;
      if (reviewsText) reviewsText.innerHTML = `${average.toFixed(1)} uit ${quantity} reviews`;

      // Zet tekst onder de sterren: "uit X beoordelingen"  
      const reviewTextHome = document.querySelector('.review-block p');
      if (reviewTextHome){
        reviewTextHome.innerHTML = `uit ${quantity} reviews`;
      }

      const reviewScore = document.querySelector('.review-block button');
      if (reviewScore){
        reviewScore.innerHTML = average.toFixed(1);
      }

      const moreReviews = document.querySelector('.btn--more-reviews');
      if (moreReviews){
        moreReviews.innerHTML = `Bekijk alle ${quantity} reviews`;
      }

      // Stel dynamische breedte in voor sterren
      document.querySelectorAll('.fill-ratings').forEach((fillEl) => {
        fillEl.style.width = `${(average / 10) * 100}%`;
      });

      // Function to generate star icons based on rating
      function generateStarIcons(rating) {
        // Convert 10-point scale to 5-star scale
        const starRating = rating / 2;
        const fullStars = Math.floor(starRating);
        const hasHalfStar = starRating % 1 >= 0.5;
        const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
        
        let starsHtml = '';
        
        // Full stars
        for (let i = 0; i < fullStars; i++) {
          starsHtml += '<i class="bx bxs-star"></i>';
        }
        
        // Half star
        if (hasHalfStar) {
          starsHtml += '<i class="bx bxs-star-half"></i>';
        }
        
        // Empty stars
        for (let i = 0; i < emptyStars; i++) {
          starsHtml += '<i class="bx bx-star"></i>';
        }
        
        return starsHtml;
      }

      // Update elements with data-reviews-* attributes
      const reviewsStars = document.querySelectorAll('[data-reviews-stars]');
      reviewsStars.forEach(element => {
        element.innerHTML = generateStarIcons(average);
      });

      const reviewsDescriptions = document.querySelectorAll('[data-reviews-description]');
      reviewsDescriptions.forEach(element => {
        element.innerHTML = `${average.toFixed(1)} uit ${quantity} reviews`;
      });

      // Update href for review links if needed
      const reviewsLinks = document.querySelectorAll('[data-reviews-link]');
      reviewsLinks.forEach(link => {
        // Keep existing href or you could update it to point to your reviews page
        // link.href = 'your-reviews-page-url';
      });
    })
    .catch(console.error);

  // 7. Wishlist functionality
  let lastWishlistNumber = null;

// Function to replace content with trash icon
function replaceWithTrashIcon() {
  const elements = document.querySelectorAll('.xb-list-style__product-del');
  elements.forEach(el => {
    // Only replace if it hasn’t been done already
    if (!el.dataset.trashIconAdded) {
      el.innerHTML = '';
      const icon = document.createElement('i');
      icon.className = 'bx bx-trash';
      el.appendChild(icon);
      el.dataset.trashIconAdded = "true"; // prevent duplicates
    }
  });
}

function replaceWishlistTitle() {
  const titles = document.querySelectorAll('.xb-wishlist-modal__title');
  titles.forEach(title => {
    if (title.textContent.trim() !== "Wishlist") {
      title.textContent = "Wishlist";
    }
  });
}

const observer = new MutationObserver(() => {
  // Wishlist button
  const realWishlistBtn = document.querySelector(".xb-wishlist-button button");
  const fakeWishlistBtns = document.querySelectorAll(".fake-wishlist-btn");

  if (realWishlistBtn && fakeWishlistBtns.length > 0) {
    fakeWishlistBtns.forEach(btn => {
      if (!btn.dataset.listenerAdded) {
        btn.addEventListener("click", e => {
          e.preventDefault();
          realWishlistBtn.click();

          // update nummer direct
          const realNumberElem = document.querySelector(".xb-wishlist__float-style-1-number");
          const fakeNumberElems = document.querySelectorAll(".fake-wishlist-cart__nr");
          if (realNumberElem && fakeNumberElems.length > 0) {
            const value = realNumberElem.textContent.trim();
            fakeNumberElems.forEach(fakeNr => {
              fakeNr.textContent = value === "0" ? "" : value;
            });
            lastWishlistNumber = value;
          }
        });
        btn.dataset.listenerAdded = "true";
      }
    });
  }

  const realCartBtn = document.querySelector("xb-wishlist-float button");
  const fakeCartBtns = document.querySelectorAll(".fake-wishlist-cart");

  if (realCartBtn && fakeCartBtns.length > 0) {
    fakeCartBtns.forEach(btn => {
      if (!btn.dataset.listenerAdded) {
        btn.addEventListener("click", e => {
          e.preventDefault();
          realCartBtn.click();

          const realNumberElem = document.querySelector(".xb-wishlist__float-style-1-number");
          const fakeNumberElems = document.querySelectorAll(".fake-wishlist-cart__nr");
          if (realNumberElem && fakeNumberElems.length > 0) {
            const value = realNumberElem.textContent.trim();
            fakeNumberElems.forEach(fakeNr => {
              fakeNr.textContent = value === "0" ? "" : value;
            });
            lastWishlistNumber = value;
          }
        });
        btn.dataset.listenerAdded = "true";
      }
    });
  }

  const realNumberElem = document.querySelector(".xb-wishlist__float-style-1-number");
  const fakeNumberElems = document.querySelectorAll(".fake-wishlist-cart__nr");
  if (realNumberElem && fakeNumberElems.length > 0) {
    const value = realNumberElem.textContent.trim();
    if (value !== lastWishlistNumber) {
      fakeNumberElems.forEach(fakeNr => {
        fakeNr.textContent = value === "0" ? "" : value;
      });
      lastWishlistNumber = value;
    }
  }

  replaceWithTrashIcon();
  replaceWishlistTitle();
});

observer.observe(document.body, { childList: true, subtree: true });

}); // End of DOMContentLoaded
